export default __webpack_public_path__ + "static/media/en.a3e6d90f.svg";